import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Table } from 'antd';
import { UserOutlined, CarOutlined, DollarOutlined } from '@ant-design/icons';
import ApiService from '../services/api';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const data = await ApiService.getDashboardData();
      setDashboardData(data);
    } catch (error) {
      console.error('Error loading dashboard:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response,
        status: error.response?.status,
        data: error.response?.data
      });
    } finally {
      setLoading(false);
    }
  };



  return (
    <div>
      <h1>Dashboard</h1>
      
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}>
          <Card>
            <Statistic
              title="Total Drivers"
              value={dashboardData?.total_drivers || 0}
              prefix={<UserOutlined />}
              loading={loading}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Total Trucks"
              value={dashboardData?.total_trucks || 0}
              prefix={<CarOutlined />}
              loading={loading}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Active Routes"
              value={dashboardData?.drivers?.filter(d => d.truck_id)?.length || 0}
              prefix={<DollarOutlined />}
              loading={loading}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Card title="Fleet & Driver Overview" loading={loading}>
            <Table
              dataSource={dashboardData?.trucks || []}
              columns={[
                { title: 'License Plate', dataIndex: 'license_plate', key: 'license_plate' },
                { title: 'Make/Model', key: 'vehicle', render: (record) => `${record.make} ${record.model}` },
                { 
                  title: 'Driver', 
                  key: 'driver_name', 
                  render: (record) => {
                    if (!dashboardData?.drivers) return 'Unassigned';
                    const driver = dashboardData.drivers.find(d => d && d.truck_id === record.truck_id);
                    return driver?.name || 'Unassigned';
                  }
                },
                { 
                  title: 'Driver Email', 
                  key: 'driver_email', 
                  render: (record) => {
                    if (!dashboardData?.drivers) return '-';
                    const driver = dashboardData.drivers.find(d => d && d.truck_id === record.truck_id);
                    return driver?.email || '-';
                  }
                }
              ]}
              pagination={{ pageSize: 10 }}
              rowKey="truck_id"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;